module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header', {
    attrs: {
      "domain_details": _vm.domain_details,
      "is90d": _vm.is90d
    }
  }), _vm._v(" "), _c('app-sidebar', {
    attrs: {
      "is90d": _vm.is90d
    }
  }), _vm._v(" "), _c('router-view', {
    key: _vm.$route.path,
    attrs: {
      "domain_details": _vm.domain_details
    }
  }), _vm._v(" "), _c('app-footer'), _vm._v(" "), _c('control-sidebar')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5746ef38!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = 696
// module chunks = 2